// @ts-nocheck
// Page: consent  (no-payment consent — subscription + disclosure agreements)
//
// Ported from the inline <script> in
//   Enrollment_modules/consent/form.module/module.html (lines 202–1529).
//
// MECHANICAL PORT — runtime behaviour is preserved. Deliberate changes:
//   1. Inline onclick handlers stripped from markup and re-bound root-scoped
//      via bind() at end of init (no window leakage).
//   2. enrollment.nautilussolar.com/_hcms/api/* -> apiUrl(); same-origin
//      redirects -> root-relative paths.
//   3. localStorage.getItem/setItem/removeItem -> storage.rawGet/rawSet/rawRemove.
//   4. @ts-nocheck used for bare-minimum migration; proper typing is a follow-up.
//
// NOTE: document.querySelector('#page_3_no_payment_required_consent_widget')
//   reaches the HubSpot-generated module wrapper which is the parent of root —
//   these selectors must stay document-scoped (same pattern as usage-il-bayou's
//   .page1lmileftright_myusage wrapper). Root-scoping is a planned fast-follow.
// NOTE: agreement documents live in agreements/ as versioned HTML assets and
//   are fetched per state through js/src/agreements/consent-agreements.

import { createTemplateGate, loadStateAgreements } from "../../agreements/consent-agreements"
import { apiUrl } from "../../core/api"
import * as storage from "../../core/storage"
import { beginOperation, type LoadingOperationHandle } from "../../ui/loading-modal"

export function init(root: HTMLElement, _config: unknown): void {
__ea_trace("modules/consent/consent.ts","init",[root,_config],["root","_config"]);
  const bind = (sel: string, type: string, fn: (e: any) => void) => {
__ea_trace("modules/consent/consent.ts","bind",[sel,type,fn],["sel","type","fn"]);
    const el = root.querySelector(sel)
    if (el) el.addEventListener(type, fn)
  }

  // ─── Loading modal ─────────────────────────────────────────────────────────
  // Mechanical migration of the former fake-timer progress bar to the shared,
  // accessible loading modal (js/src/ui/loading-modal.ts). Kind "mutation" so a
  // genuine hang shows honest "may still be processing" copy with a Close escape,
  // never a fabricated 100%. The former 100s fake-timer sweep and its
  // interval-leak are gone by construction. A deferred audit will split this into
  // read vs mutation withLoader boundaries with abort/idempotency semantics.
  let loaderHandle: LoadingOperationHandle | null = null
  function openProgressBarPN(message = "We are saving your payment information"): void {
__ea_trace("modules/consent/consent.ts","openProgressBarPN",[message],["message"]);
    loaderHandle = beginOperation({ kind: "mutation", message })
  }
  function closeProgressBarPN(): void {
__ea_trace("modules/consent/consent.ts","closeProgressBarPN",[],[]);
    loaderHandle?.complete()
    loaderHandle = null
  }

  // Consent agreement helpers
  function validateAgreementFullName(root, agreement) {
__ea_trace("modules/consent/consent.ts","validateAgreementFullName",[root,agreement],["root","agreement"]);
    if (!agreement.isVisible()) {
      return null
    }

    var value = root.querySelector(agreement.fullNameSelector).value.trim()
    var errorMessage = root.querySelector(agreement.fullNameErrorSelector)

    if (value === "") {
      errorMessage.innerHTML = "Please enter your Full Name."
      return "error"
    }
    if (!/^[a-zA-Z ]+$/.test(value)) {
      errorMessage.innerHTML = "Please enter a valid Full Name with only alphabetic characters."
      return "error"
    }

    errorMessage.innerHTML = ""
    return null
  }

  function validateAgreementCheckbox(root, agreement, isHeaderCheckbox) {
__ea_trace("modules/consent/consent.ts","validateAgreementCheckbox",[root,agreement,isHeaderCheckbox],["root","agreement","isHeaderCheckbox"]);
    if (!agreement.isVisible()) {
      return null
    }

    var checkboxSelector = isHeaderCheckbox ? agreement.headerCheckboxSelector : agreement.checkboxSelector
    var errorSelector = isHeaderCheckbox ? agreement.headerCheckboxErrorSelector : agreement.checkboxErrorSelector
    var errorMessage = isHeaderCheckbox ? agreement.headerCheckboxError : agreement.checkboxError
    var checkbox = root.querySelector(checkboxSelector)

    if (!checkbox.checked) {
      root.querySelector(errorSelector).innerHTML = errorMessage
      return "error"
    }

    root.querySelector(errorSelector).innerHTML = ""
    return null
  }

  function bindSignatureThanks(input, thanksText) {
__ea_trace("modules/consent/consent.ts","bindSignatureThanks",[input,thanksText],["input","thanksText"]);
    input.addEventListener("keyup", () => {
__ea_trace("modules/consent/consent.ts","(anon)",[],[]);
      thanksText.style.display = input.value.trim() === "" ? "none" : "block"
    })
  }
  // Consent agreement helpers end

  const consentWidget = document.querySelector("#page_3_no_payment_required_consent_widget")
  const consentAgreements = {
    subscription: {
      fullNameSelector: "#subscription_fullName",
      fullNameErrorSelector: "#subscription_fullName_error_message",
      checkboxSelector: "#subscription_checkbox",
      checkboxErrorSelector: "#subscription_checkbox_error_message",
      checkboxError: "Please check the box to agree to the Subscription Agreement.",
      headerCheckboxSelector: "#subscription_checkbox_header",
      headerCheckboxErrorSelector: "#subscription_Firstcheckbox_error_message",
      headerCheckboxError: "Please enter your full name to agree to the Subscription Agreement.",
      isVisible: () => showSubscription,
    },
    disclosure: {
      fullNameSelector: "#disclosure_fullName",
      fullNameErrorSelector: "#disclosure_fullName_error_message",
      checkboxSelector: "#disclosure_checkbox",
      checkboxErrorSelector: "#disclosure_checkbox_error_message",
      checkboxError: "Please check the box to agree to the Disclosure Agreement.",
      headerCheckboxSelector: "#disclosure_checkbox_header",
      headerCheckboxErrorSelector: "#disclosure_Firstcheckbox_error_message",
      headerCheckboxError: "Please enter your full name to agree to the Disclosure Agreement.",
      isVisible: () => showDisclosure,
    },
  }

  bindSignatureThanks(
    consentWidget.querySelector("#subscription_fullName"),
    consentWidget.querySelector("#subscription_thanktext"),
  )
  bindSignatureThanks(
    consentWidget.querySelector("#disclosure_fullName"),
    consentWidget.querySelector("#disclosure_thanktext"),
  )
  /* loader function */
  function _paymentNotRequiredOpenLoader() {
__ea_trace("modules/consent/consent.ts","_paymentNotRequiredOpenLoader",[],[]);
    var loader = document.getElementById("paymentNotRequiredLoader")
    var _body = document.querySelector("body")
    var buttons = document.querySelectorAll("button")
    var anchors = document.querySelectorAll("a")
    document.getElementById("PNRloaderOverlay").style.display = "block"
    loader.style.display = "flex"
    buttons.forEach((button) => {
__ea_trace("modules/consent/consent.ts","(anon)",[button],["button"]);
      button.disabled = true
    })
    anchors.forEach((anchor) => {
__ea_trace("modules/consent/consent.ts","(anon)",[anchor],["anchor"]);
      anchor.disabled = true
    })
  }
  function _paymentNotRequiredCloseLoader() {
__ea_trace("modules/consent/consent.ts","_paymentNotRequiredCloseLoader",[],[]);
    var loader = document.getElementById("paymentNotRequiredLoader")
    var _body = document.querySelector("body")
    var buttons = document.querySelectorAll("button")
    var anchors = document.querySelectorAll("a")
    document.getElementById("PNRloaderOverlay").style.display = "none"
    loader.style.display = "none"
    buttons.forEach((button) => {
__ea_trace("modules/consent/consent.ts","(anon)",[button],["button"]);
      button.disabled = false
    })
    anchors.forEach((anchor) => {
__ea_trace("modules/consent/consent.ts","(anon)",[anchor],["anchor"]);
      anchor.disabled = false
    })
  }
  /* loader function */

  // --- Go back personal information button ---------------------------------
  document
    .querySelector("#page_3_no_payment_required_consent_widget #goback-personal-info")
    .addEventListener("click", () => {
__ea_trace("modules/consent/consent.ts","(anon)",[],[]);
      var cp = storage.rawGet("credentialProvider")
      var lmiOption = storage.rawGet("lmi_option")
      if (cp === "NSE (Hansen)" && lmiOption === "Threshold Opt-Out") {
        window.location.href = "/my-usage" // redirect to normal hansen myusage page
      } else if (cp === "Bayou" && lmiOption === "Threshold Opt-Out") {
        window.location.href = "/myusage" // redirect to normal bayou myusage page
      } else if (cp === "NSE (Hansen)" && lmiOption === "null") {
        window.location.href = "/my-usage" // redirect to normal hansen myusage page
      } else if (cp === "Bayou" && lmiOption === "null") {
        window.location.href = "/myusage" // redirect to normal bayou myusage page
      } else if (cp === "Bayou") {
        window.location.href = "/my_usage" // redirect to lmi bayou myusage page
      } else if (cp === "NSE (Hansen)") {
        window.location.href = "/my-usage-lh" // redirect to lmi hansen myusage page
      } else {
        window.location.href = "/my-usage"
      }
    })
  // --- Go back personal information button ---------------------------------
  ;[
    ["#sa-download-a-copy-anchor", "click", savePdfSubAgreement],
    ["#sa-print-a-copy-anchor", "click", printSubAgreement],
    ["#dsc-download-a-copy-anchor", "click", savePdfDisclosure],
    ["#dsc-print-a-copy-anchor", "click", printDisclosure],
    ["#subscription_fullName", "input", validateSub_fullName_NR],
    ["#subscription_checkbox", "change", validateSub_checkbox_NR],
    ["#subscription_checkbox_header", "change", validateSub_Firstcheckbox_NR],
    ["#disclosure_fullName", "input", validateDis_fullName_NR],
    ["#disclosure_checkbox", "change", validateDis_checkbox_NR],
    ["#disclosure_checkbox_header", "change", validateDis_Firstcheckbox_NR],
  ].forEach((binding) => {
__ea_trace("modules/consent/consent.ts","(anon)",[binding],["binding"]);
    consentWidget.querySelector(binding[0]).addEventListener(binding[1], binding[2])
  })

  function validateSub_fullName_NR() {
__ea_trace("modules/consent/consent.ts","validateSub_fullName_NR",[],[]);
    return validateAgreementFullName(consentWidget, consentAgreements.subscription)
  }
  function validateSub_checkbox_NR() {
__ea_trace("modules/consent/consent.ts","validateSub_checkbox_NR",[],[]);
    return validateAgreementCheckbox(consentWidget, consentAgreements.subscription, false)
  }
  function validateSub_Firstcheckbox_NR() {
__ea_trace("modules/consent/consent.ts","validateSub_Firstcheckbox_NR",[],[]);
    return validateAgreementCheckbox(consentWidget, consentAgreements.subscription, true)
  }
  function validateDis_fullName_NR() {
__ea_trace("modules/consent/consent.ts","validateDis_fullName_NR",[],[]);
    return validateAgreementFullName(consentWidget, consentAgreements.disclosure)
  }
  function validateDis_checkbox_NR() {
__ea_trace("modules/consent/consent.ts","validateDis_checkbox_NR",[],[]);
    return validateAgreementCheckbox(consentWidget, consentAgreements.disclosure, false)
  }
  function validateDis_Firstcheckbox_NR() {
__ea_trace("modules/consent/consent.ts","validateDis_Firstcheckbox_NR",[],[]);
    return validateAgreementCheckbox(consentWidget, consentAgreements.disclosure, true)
  }
  document
    .querySelector("#page_3_no_payment_required_consent_widget #get-utility-info")
    .addEventListener("click", validateForm_NR)
  function validateForm_NR() {
__ea_trace("modules/consent/consent.ts","validateForm_NR",[],[]);
    openProgressBarPN("We are securing all of your finalized data.")

    // Call individual validation functions
    document.querySelector("#page_3_no_payment_required_consent_widget #final-error-message").innerHTML = ""
    validateSub_fullName_NR()
    validateSub_checkbox_NR()
    validateSub_Firstcheckbox_NR()
    if (IsValidateDisclosure) {
      validateDis_fullName_NR()
      validateDis_checkbox_NR()
      validateDis_Firstcheckbox_NR()
    }

    // Check if any error messages are present
    var errorMessages = document.querySelectorAll("#page_3_no_payment_required_consent_widget .error-message")
    var hasErrors = false
    for (var i = 0; i < errorMessages.length; i++) {
      if (errorMessages[i].innerHTML !== "") {
        hasErrors = true
        closeProgressBarPN()
        break
      }
    }
    // If there are errors, prevent form submission
    if (hasErrors) {
      closeProgressBarPN()
      document.querySelector("#page_3_no_payment_required_consent_widget #final-error-message").innerHTML =
        "There are errors in the form above. Please scroll up and correct them to continue."
      return false
    } else {
      document.querySelector("#page_3_no_payment_required_consent_widget #final-error-message").innerHTML = ""
    }

    // If no errors, allow form submission
    addAgreementDisclosureDataToDealRecord_NR()
    return true
  }

  async function delay(ms) {
__ea_trace("modules/consent/consent.ts","delay",[ms],["ms"]);
    return new Promise((resolve) => setTimeout(resolve, ms))
  }
  function _getCurrentTimestamp() {
__ea_trace("modules/consent/consent.ts","_getCurrentTimestamp",[],[]);
    const now = new Date()

    const year = now.getFullYear()
    const month = String(now.getMonth() + 1).padStart(2, "0")
    const day = String(now.getDate()).padStart(2, "0")

    const hours = String(now.getHours()).padStart(2, "0")
    const minutes = String(now.getMinutes()).padStart(2, "0")
    const seconds = String(now.getSeconds()).padStart(2, "0")

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
  }
  var _ipAddress = ""
  // Example usage
  async function _getPublicIP() {
__ea_trace("modules/consent/consent.ts","_getPublicIP",[],[]);
    try {
      const response = await fetch("https://api.ipify.org?format=json")
      const data = await response.json()
      _ipAddress = data.ip
    } catch (error) {
      console.error("Error fetching public IP:", error)
    }
  }

  var pwd
  var upwd
  function dp(val) {
__ea_trace("modules/consent/consent.ts","dp",[val],["val"]);
    pwd = crypt.decrypt(val)
  }
  function dup(val) {
__ea_trace("modules/consent/consent.ts","dup",[val],["val"]);
    upwd = crypt.decrypt(val)
  }
  async function getLoginPassNP() {
__ea_trace("modules/consent/consent.ts","getLoginPassNP",[],[]);
    openProgressBarPN("We are securing all of your finalized data.")
    var email = storage.rawGet("userEmail")
    var catchdata = ""
    try {
      const data = {
        email: email,
      }
      const response = await fetch(apiUrl("GetContactRecordBasedOnEmail"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
      catchdata = data
      const dataa = await response.json()
      responseFromAPI = JSON.stringify(dataa)
      const pr = dataa.userValue.properties.password
      dp(pr)
      if (dataa.message === "No User Found") {
      } else if (dataa.message === "User Found") {
        if (pwd !== "") {
          if (pr !== pwd) {
            await FPUpdatePasswordNP(email, pwd)
          }
        }
      }
    } catch (error) {
      console.error("Error:", error)
    }
  }
  async function FPUpdatePasswordNP(email, pwd) {
__ea_trace("modules/consent/consent.ts","FPUpdatePasswordNP",[email,pwd],["email","pwd"]);
    var catchdata = ""
    try {
      const data = {
        properties: {
          email: email,
          password: pwd,
        },
      }
      const response = await fetch(apiUrl("UpdateContactRecord"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
      catchdata = data

      const result = await response.json()
      responseFromAPI = JSON.stringify(result)
    } catch (error) {
      console.error("Error:", error)
    }
  }
  async function GetUtilityPassNP() {
__ea_trace("modules/consent/consent.ts","GetUtilityPassNP",[],[]);
    var dealId = storage.rawGet("dealId")
    var catchdata = ""
    try {
      const data = {
        deal_id: dealId,
      }
      const response = await fetch(apiUrl("GetDealRecordBasedOnEmail"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
      catchdata = data
      const dataa = await response.json()
      responseFromAPI = JSON.stringify(dataa)

      // BUGFIX: original had a bare `else if` with no preceding `if` — syntax
      // error that prevented the browser from parsing the whole inline script.
      if (dataa.message === "User Found") {
        var utps = dataa.userValue.properties.utility_password
        if (utps != null && utps !== "" && utps !== "null") {
          dup(utps)
        }
        if (upwd !== "" && upwd != null && upwd !== "null") {
          await updateUtilityPasswordNP(upwd)
        }
      }
    } catch (error) {
      console.error("Error:", error)
    }
  }
  async function updateUtilityPasswordNP(pwd) {
__ea_trace("modules/consent/consent.ts","updateUtilityPasswordNP",[pwd],["pwd"]);
    var dealId = storage.rawGet("dealId")
    var catchdata = ""
    try {
      const data = {
        properties: {
          deal_id: dealId,
          utility_password: pwd,
        },
      }
      const response = await fetch(apiUrl("UpdateDealRecord"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
      catchdata = data

      const result = await response.json()
      responseFromAPI = JSON.stringify(result)
    } catch (error) {
      console.error("Error:", error)
    }
  }
  /* --------------------------------------------------- dcrypted password on submit stage ------------------------------------------------------ */

  // - add data to deal record on get utility button click ----------------------------------------------------------
  async function addAgreementDisclosureDataToDealRecord_NR() {
__ea_trace("modules/consent/consent.ts","addAgreementDisclosureDataToDealRecord_NR",[],[]);
    var subscription_fullName = document
      .querySelector("#page_3_no_payment_required_consent_widget #subscription_fullName")
      .value.trim()
    var subscription_checkbox = document.querySelector(
      "#page_3_no_payment_required_consent_widget #subscription_checkbox",
    )
    if (!subscription_checkbox.checked) {
      subscription_checkbox = false
    } else {
      subscription_checkbox = true
    }
    var disclosure_fullName = document
      .querySelector("#page_3_no_payment_required_consent_widget #disclosure_fullName")
      .value.trim()
    var disclosure_checkbox = document.querySelector("#page_3_no_payment_required_consent_widget #disclosure_checkbox")

    if (!disclosure_checkbox.checked) {
      disclosure_checkbox = false
    } else {
      disclosure_checkbox = true
    }
    var dealId = storage.rawGet("dealId")
    var catchdata = ""
    var responseFromAPI = ""
    try {
      await uploadPdf()
      const data = {
        properties: {
          deal_id: dealId,
          subscription_acknowledgement: subscription_checkbox,
          subscription_signature_typed: subscription_fullName,
          disclosure_acknowledgement: disclosure_checkbox,
          disclosure_signature_typed: disclosure_fullName,
          lmi_saa_doc_file_1: SubAgreementUrl,
          lmi_saa_doc_file_2: DiscAgreementUrl,
          saa_document_sub_type_1: showSubscription ? utilityDetailsNr["75"][0].label : "",
          saa_document_sub_type_2: showDisclosure ? utilityDetailsNr["76"][0].label : "",
        },
      }
      const response = await fetch(apiUrl("UpdateDealRecord"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
      catchdata = data
      if (response.ok) {
        var value = storage.rawGet("skipUsage")
        if (value === "Yes") {
          updateDealStage_NR("127892570")
          storage.rawSet("typ", "UtAsTaNc")

          await delay(10000)
          closeProgressBarPN()
          window.location.href = "/thank-you"
        } else if (value === "No") {
          updateDealStage_NR("127892570")
          storage.rawSet("typ", "lMiAsTaNc")
          await getLoginPassNP()
          await GetUtilityPassNP()

          await delay(10000)
          closeProgressBarPN()
          window.location.href = "/thank-you"
        } else {
          updateDealStage_NR("127892570")
          storage.rawSet("typ", "lMiAsTaNc")
          await getLoginPassNP()
          await GetUtilityPassNP()

          await delay(10000)
          closeProgressBarPN()
          window.location.href = "/thank-you"
        }
      }
      const result = await response.json()
      responseFromAPI = JSON.stringify(result)
    } catch (error) {
      closeProgressBarPN()
      console.error("Error:", error)
    }
  }
  // - add data to deal record on get utility button click ----------------------------------------------------------

  // update Deal Stage -------------------------------------------------------------------------------
  async function updateDealStage_NR(value) {
__ea_trace("modules/consent/consent.ts","updateDealStage_NR",[value],["value"]);
    if (storage.rawGet("skipUsage") != null && storage.rawGet("skipUsage") === "Yes") {
      value = "127892571"
    } else {
      if (storage.rawGet("credentialProvider") === "Bayou") {
        value = "127892570" // Verify HU (Sales Pipeline)
      }
      storage.rawSet("DealStage", "Submitted")
    }
    var dealId = storage.rawGet("dealId")
    await delay(2000)
    var catchdata = ""
    try {
      const data = {
        properties: {
          deal_id: dealId,
          dealstage: value,
        },
      }
      const response = await fetch(apiUrl("UpdateDealRecord"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
      catchdata = data

      const result = await response.json()
      responseFromAPI = JSON.stringify(result)
    } catch (error) {
      console.error("Error:", error)
    }
    return true
  }
  //- update deaLstage -------------------------------------------------------------------------------

  // - Save my place button click -----------------------------------------------------------------------------------
  document
    .querySelector("#page_3_no_payment_required_consent_widget #save-remind")
    .addEventListener("click", saveAgreementDisclosureDataToDealRecord_NR)

  // - Save data to deal record on get utility button click ----------------------------------------------------------
  async function saveAgreementDisclosureDataToDealRecord_NR() {
__ea_trace("modules/consent/consent.ts","saveAgreementDisclosureDataToDealRecord_NR",[],[]);
    var subscription_fullName = document
      .querySelector("#page_3_no_payment_required_consent_widget #subscription_fullName")
      .value.trim()
    var subscription_checkbox = document.querySelector(
      "#page_3_no_payment_required_consent_widget #subscription_checkbox",
    )
    if (!subscription_checkbox.checked) {
      subscription_checkbox = false
    } else {
      subscription_checkbox = true
    }
    var disclosure_fullName = document
      .querySelector("#page_3_no_payment_required_consent_widget #disclosure_fullName")
      .value.trim()
    var disclosure_checkbox = document.querySelector("#page_3_no_payment_required_consent_widget #disclosure_checkbox")

    if (!disclosure_checkbox.checked) {
      disclosure_checkbox = false
    } else {
      disclosure_checkbox = true
    }
    var dealId = storage.rawGet("dealId")
    var _catchdata = ""
    try {
      const data = {
        properties: {
          deal_id: dealId,
          subscription_acknowledgement: subscription_checkbox,
          subscription_signature_typed: subscription_fullName,
          disclosure_acknowledgement: disclosure_checkbox,
          disclosure_signature_typed: disclosure_fullName,
          lmi_saa_doc_file_1: SubAgreementUrl,
          lmi_saa_doc_file_2: DiscAgreementUrl,
          saa_document_sub_type_1: showSubscription ? utilityDetailsNr["75"][0].label : "",
          saa_document_sub_type_2: showDisclosure ? utilityDetailsNr["76"][0].label : "",
        },
      }
      const response = await fetch(apiUrl("UpdateDealRecord"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
      var catchdata = data

      const result = await response.json()
      responseFromAPI = JSON.stringify(result)
    } catch (error) {
      closeProgressBarPN()
      console.error("Error:", error)
    }
  }
  // - Save data to deal record on get utility button click ----------------------------------------------------------

  // pdf and print ---------------------------------------------------------------------
  var loggedName = storage.rawGet("LoggedName")
  var loggedAddress = storage.rawGet("Address")
  var loggedEmail = storage.rawGet("userEmail")
  var IsValidateDisclosure = true

  document.querySelector("#page_3_no_payment_required_consent_widget #SubAgree-para").innerHTML =
    `I, <strong>${loggedName}</strong>, acknowledge that typing my name below constitutes my electronic signature. I understand this carries the same legal enforceability as my hand-written signature.`
  document.querySelector("#page_3_no_payment_required_consent_widget #disclosure-para").innerHTML =
    `I, <strong>${loggedName}</strong>, acknowledge that typing my name below constitutes my electronic signature. I understand this carries the same legal enforceability as my hand-written signature.`

  ///////Pdf Code FRom here\\\\\..........................
  var Farm_LLC = storage.rawGet("FarmLlc")
  var Farm_Project_Description = storage.rawGet("FarmProjectDescription")
  var Farm_Phone_Number = storage.rawGet("FarmPhoneNumber")
  var Farm_LLC_Address1 = storage.rawGet("FarmStreetAddress1")

  var Farm_LLC_Address2 = ""
  if (storage.rawGet("FarmStreetAddress2") === undefined || storage.rawGet("FarmStreetAddress2") === "undefined") {
    Farm_LLC_Address2 = ""
  } else {
    Farm_LLC_Address2 = storage.rawGet("FarmStreetAddress2")
  }
  var Farm_LLC_City = storage.rawGet("FarmCity")
  var Farm_LLC_State = storage.rawGet("FarmStateAbbreviation")
  var Farm_LLC_Zip = storage.rawGet("zip_code")
  var Farm_LLC_Email = storage.rawGet("FarmEmail")
  var subscriptionSignedName = storage.rawGet("LoggedName")
  var _disclosureSignedName = ""
  var SessionLogo = JSON.parse(storage.rawGet("UtilitySessionDetails"))["17"].url
  var _logowidth = JSON.parse(storage.rawGet("UtilitySessionDetails"))["17"].width
  var _logoheight = JSON.parse(storage.rawGet("UtilitySessionDetails"))["17"].height
  var today = new Date()

  // Get the day, month, and year
  var day = String(today.getDate()).padStart(2, "0")
  var month = String(today.getMonth() + 1).padStart(2, "0") // January is 0!
  var year = today.getFullYear()

  // Concatenate the parts to form the date in "dd mm yyyy" format
  var formattedDate = `${day} ${month} ${year}`

  var showSubscription = false
  var showDisclosure = false
  var stageNameNR

  var utilityDetailsNr = storage.rawGet("UtilitySessionDetails")
  var _finalSubTempNr
  var _finalDisclosureTempNr

  if (utilityDetailsNr) {
    utilityDetailsNr = JSON.parse(utilityDetailsNr)
    stageNameNR = utilityDetailsNr["13"].name
    if (utilityDetailsNr["75"] && utilityDetailsNr["75"].length > 0) {
      if (utilityDetailsNr["75"][0].name === "agreement" || utilityDetailsNr["75"][0].name === "terms_conditions") {
        showSubscription = true
      } else {
        document.querySelector(
          "#page_3_no_payment_required_consent_widget .subscription-agreement-main",
        ).style.display = "none"
      }
    } else {
      document.querySelector("#page_3_no_payment_required_consent_widget .subscription-agreement-main").style.display =
        "none"
    }
    if (utilityDetailsNr["76"] && utilityDetailsNr["76"].length > 0) {
      if (utilityDetailsNr["76"][0].name === "agreement" || utilityDetailsNr["76"][0].name === "disclosure") {
        showDisclosure = true
      } else {
        document.querySelector("#page_3_no_payment_required_consent_widget .disclosure-main").style.display = "none"
      }
    } else {
      document.querySelector("#page_3_no_payment_required_consent_widget .disclosure-main").style.display = "none"
    }
  }

  // Values the agreement assets render. Derived here rather than read from
  // consent-pay: both consent widgets render on the same page, and the
  // no-payment flow must not depend on the payment module's variables.
  var loggedCity = storage.rawGet("city") ?? ""
  var loggedCounty = storage.rawGet("county") ?? ""
  var loggedState = storage.rawGet("stateForLMIConfig") ?? ""
  var loggedZip = storage.rawGet("zip_code") ?? ""
  var loggedHomePhone = storage.rawGet("HomePhone") ?? ""
  var loggedCellPhone = storage.rawGet("CellPhone") ?? ""
  var streetAddress = storage.rawGet("Street Address") ?? ""
  var retailCustomerNumber = storage.rawGet("UanNumber") ?? ""
  var standardDiscount = storage.rawGet("FarmOpenDiscount") ?? ""
  var lmiDiscount = storage.rawGet("FarmLMIDiscount") ?? ""
  var Farm_LLC_Id = storage.rawGet("FarmID") ?? ""
  var Farm_Display_Name = storage.rawGet("FarmDisplayName") ?? ""
  var userTitle = ""

  // dd mm yyyy is `formattedDate`, declared above with the other date parts.
  var formattedDate2 = `${month}/${day}/${year}`
  var formattedDate3 = new Intl.DateTimeFormat("en-US", { month: "long" }).format(today) + " " + day + " " + year
  var formattedDaterh = `${year}-${month}-${day}`
  var formattedDateStamprh =
    formattedDaterh +
    " " +
    String(today.getHours()).padStart(2, "0") +
    ":" +
    String(today.getMinutes()).padStart(2, "0") +
    ":" +
    String(today.getSeconds()).padStart(2, "0")

  function getUtilityDisplayNameForAgreement() {
__ea_trace("modules/consent/consent.ts","getUtilityDisplayNameForAgreement",[],[]);
    try {
      var details = JSON.parse(storage.rawGet("UtilitySessionDetails") || "null")
      return details && details["5"] != null ? String(details["5"]) : ""
    } catch (error) {
      console.error("Unable to read the utility display name:", error)
      return ""
    }
  }

  // Token values per state. Kinds are split because the documents disagree
  // on date format and on whether the signer or account-holder name prints.
  function getAgreementValues(state) {
__ea_trace("modules/consent/consent.ts","getAgreementValues",[state],["state"]);
    switch (state) {
      case "Maryland":
        return {
          subscription: {
            effectiveDate: formattedDate3,
            email: loggedEmail ?? "",
            lmiDiscount: lmiDiscount,
            primaryPhone: loggedHomePhone || loggedCellPhone,
            serviceAddress: loggedAddress ?? "",
            standardDiscount: standardDiscount,
            subscriberName: loggedName ?? "",
            subscriberTitle: userTitle,
            utilityAccountNumber: storage.rawGet("uan1Value") ?? "",
          },
        }
      case "Maine":
        return {
          subscription: {
            signedDate: formattedDate,
            subscriberName: subscriptionSignedName ?? "",
            utilityLogoUrl: SessionLogo ?? "",
          },
          disclosure: {
            projectAddressLine1: Farm_LLC_Address1 ?? "",
            projectAddressLine2: Farm_LLC_Address2 ?? "",
            projectCity: Farm_LLC_City ?? "",
            projectCompanyName: Farm_LLC ?? "",
            projectDescription: Farm_Project_Description ?? "",
            projectEmail: Farm_LLC_Email ?? "",
            projectPhone: Farm_Phone_Number ?? "",
            projectState: Farm_LLC_State ?? "",
            projectZip: Farm_LLC_Zip ?? "",
          },
        }
      case "Delaware":
        return {
          subscription: {
            email: loggedEmail ?? "",
            lmiDiscount: lmiDiscount,
            primaryPhone: loggedHomePhone || loggedCellPhone,
            signedDate: formattedDate2,
            subscriberName: loggedName ?? "",
            subscriberSignatureName: subscriptionSignedName ?? "",
          },
        }
      case "Colorado":
        return {
          subscription: {
            alternatePhone: loggedCellPhone || loggedHomePhone,
            email: loggedEmail ?? "",
            primaryPhone: loggedHomePhone || loggedCellPhone,
            projectAddressLine1: Farm_LLC_Address1 ?? "",
            projectAddressLine2: Farm_LLC_Address2 ?? "",
            projectCompanyName: Farm_LLC ?? "",
            projectDisplayName: Farm_Display_Name,
            projectId: Farm_LLC_Id,
            retailCustomerNumber: retailCustomerNumber,
            serviceAddress: loggedAddress ?? "",
            serviceState: loggedState,
            serviceZip: loggedZip,
            signedDate: formattedDate2,
            subscriberName: subscriptionSignedName ?? "",
          },
          disclosure: {
            signedDate: formattedDate2,
            subscriberName: loggedName ?? "",
          },
        }
      case "New York":
        return {
          subscription: {
            effectiveDate: formattedDate3,
            subscriberName: loggedName ?? "",
            subscriberTitle: userTitle,
          },
          disclosure: {
            effectiveDate: formattedDate3,
            projectAddress: Farm_LLC_Address1 ?? "",
            projectCompanyName: Farm_LLC ?? "",
            serviceAddress: loggedAddress ?? "",
            subscriberName: loggedName ?? "",
            utilityDisplayName: getUtilityDisplayNameForAgreement(),
          },
        }
      case "Minnesota":
        return {
          subscription: {
            serviceAddress: loggedAddress ?? "",
            serviceCounty: loggedCounty,
            serviceState: loggedState,
            serviceZip: loggedZip,
            signedDate: formattedDate2,
            subscriberName: subscriptionSignedName ?? "",
            utilityAccountNumber: storage.rawGet("uan1Value") ?? "",
          },
        }
      case "Rhode Island":
        return {
          subscription: {
            customerName: loggedName ?? "",
            email: loggedEmail ?? "",
            primaryPhone: loggedHomePhone || loggedCellPhone,
            serviceCity: loggedCity,
            serviceState: loggedState,
            serviceStreetAddress: streetAddress,
            serviceZip: loggedZip,
            signedDate: formattedDaterh,
            signedTimestamp: formattedDateStamprh,
            subscriberSignatureName: subscriptionSignedName ?? "",
            utilityAccountNumber: storage.rawGet("uan1Value") ?? "",
          },
        }
      default:
        return { subscription: {}, disclosure: {} }
    }
  }

  // currently working functions below
  var finalSubTemp
  var finalDisclosureTemp
  var _finalDataConsentTemp

  var subDocDownloadName = "subscription_agreement.pdf"
  var disbDocDownloadName = "Disclosure.pdf"
  async function setTemplates() {
__ea_trace("modules/consent/consent.ts","setTemplates",[],[]);
    if (stageNameNR === "Delaware") {
      IsValidateDisclosure = false
      const element = document.getElementById("disclosure")
      if (element) {
        element.style.display = "none"
      }
    }
    if (stageNameNR === "Minnesota") {
      subDocDownloadName = "Subscription Agreement Signature"
    }

    var agreements = await loadStateAgreements(root, stageNameNR, getAgreementValues(stageNameNR))
    finalSubTemp = agreements.subscription
    finalDisclosureTemp = agreements.disclosure
  }

  var templateGate = createTemplateGate(setTemplates)
  var ensureTemplatesReady = templateGate.ensureReady
  var discPreviewWindow
  var subPreviewWindow
  var _dataConsentPreviewWindow

  async function previewSubTemplate() {
__ea_trace("modules/consent/consent.ts","previewSubTemplate",[],[]);
    if (!(await ensureTemplatesReady())) return
    if (discPreviewWindow && !discPreviewWindow.closed) {
      discPreviewWindow.close()
    }

    subPreviewWindow = window.open("", "SubPreview", "width=600,height=400")

    subPreviewWindow.document.write(finalSubTemp)
  }
  async function previewDiscTemplate() {
__ea_trace("modules/consent/consent.ts","previewDiscTemplate",[],[]);
    if (!(await ensureTemplatesReady())) return

    if (subPreviewWindow && !subPreviewWindow.closed) {
      subPreviewWindow.close()
    }

    discPreviewWindow = window.open("", "DiscPreview", "width=600,height=400")

    discPreviewWindow.document.write(finalDisclosureTemp)
  }
  async function savePdfDisclosure() {
__ea_trace("modules/consent/consent.ts","savePdfDisclosure",[],[]);
    try {
      if (!(await ensureTemplatesReady())) return

      var container = document.createElement("div")
      container.innerHTML = finalDisclosureTemp
      document.body.appendChild(container)

      await html2pdf()
        .from(container)
        .set({
          margin: 10,
          filename: `${disbDocDownloadName}`,
          html2canvas: { scale: 2, useCORS: true },
        })
        .save()
      document.body.removeChild(container)
    } catch (e) {
      console.error(`Error in print: ${e}`)
    }
  }
  async function savePdfSubAgreement() {
__ea_trace("modules/consent/consent.ts","savePdfSubAgreement",[],[]);
    try {
      if (!(await ensureTemplatesReady())) return

      var container = document.createElement("div")
      container.className = "pdfTemplate"
      container.innerHTML = finalSubTemp

      document.body.appendChild(container)
      if (stageNameNR === "Rhode Island") {
        // Configure and save the PDF
        await html2pdf()
          .from(container)
          .set({
            margin: [20, 0, 80, 0], // Set margins
            filename: `${subDocDownloadName}`,
            html2canvas: {
              scale: 2, // Adjust scale for content size
              logging: true,
              letterRendering: true,
            },
            jsPDF: {
              unit: "pt",
              format: "a4",
              orientation: "portrait",
            },
          })
          .save()
      } else {
        await html2pdf()
          .from(container)
          .set({
            margin: [20, 30, 80, 30], // Set margins
            filename: `${subDocDownloadName}`,
            html2canvas: {
              scale: 2, // Adjust scale for content size
              //                         logging: true,
              //                         letterRendering: true,
              useCORS: true,
            },

            jsPDF: {
              unit: "pt",
              format: "a4",
              orientation: "portrait",
            },
            pagebreak: { mode: ["css", "avoid-all"] },
          })
          .save()
      }

      document.body.removeChild(container)
    } catch (e) {
      console.error(`Error in print: ${e}`)
    }
  }

  var SubAgreementUrl = ""
  var DiscAgreementUrl = ""
  var _DataConsentAgreementUrl = ""
  var _SubAgreementId = ""
  var _DiscAgreementId = ""
  var _DataConsentAgreementId = ""
  async function _isPdfBlank(pdfBlob) {
__ea_trace("modules/consent/consent.ts","_isPdfBlank",[pdfBlob],["pdfBlob"]);
    const loadingTask = pdfjsLib.getDocument({ data: await pdfBlob.arrayBuffer() })
    const pdfDocument = await loadingTask.promise
    const numPages = pdfDocument.numPages

    for (let pageNum = 1; pageNum <= numPages; pageNum++) {
      const page = await pdfDocument.getPage(pageNum)

      const textContent = await page.getTextContent()

      if (textContent.items.length > 0) {
        return false
      }
    }

    return true
  }
  async function uploadPdf() {
__ea_trace("modules/consent/consent.ts","uploadPdf",[],[]);
    if (!(await ensureTemplatesReady())) return

    await convertAndUploadPdf(finalSubTemp, true, false)
    if (
      stageNameNR !== "Delaware" &&
      stageNameNR !== "Maryland" &&
      stageNameNR !== "Minnesota" &&
      stageNameNR !== "Rhode Island"
    ) {
      await convertAndUploadPdf(finalDisclosureTemp, false, false)
    }
  }

  //new here
  var isSubBlank = null
  var isDisBlank = null
  var _isDataConsentBlank = false
  async function convertAndUploadPdf(template, isSubAgreement, isDataConsentAgreement) {
__ea_trace("modules/consent/consent.ts","convertAndUploadPdf",[template,isSubAgreement,isDataConsentAgreement],["template","isSubAgreement","isDataConsentAgreement"]);
    return new Promise(async (resolve, reject) => {
__ea_trace("modules/consent/consent.ts","(anon)",[resolve,reject],["resolve","reject"]);
      try {
        var container = document.createElement("div")
        container.innerHTML = template
        document.body.appendChild(container)

        var isPdfBlank = false

        const pdfCanvas = await html2canvas(container, { scale: 2 })
        if (isSubAgreement) {
          isSubBlank = checkIfCanvasIsBlank(pdfCanvas)
          isPdfBlank = isSubBlank
        } else {
          isDisBlank = checkIfCanvasIsBlank(pdfCanvas)
          isPdfBlank = isDisBlank
        }

        if (isPdfBlank) {
          document.body.removeChild(container)

          if (isSubAgreement) {
            console.error("Error in generating Subscription agreement please try again later")
          } else {
            console.error("Error in generating disclosure agreement please try again later")
          }
        }
        if (stageNameNR === "Rhode Island") {
          await html2pdf()
            .from(container)
            .set({
              margin: 10,
              filename: "template.pdf",
              html2canvas: {
                scale: 2,
                useCORS: true,
              },
              jsPDF: { unit: "pt", format: [900, 841.89], orientation: "portrait" },
              pagebreak: { mode: ["css", "avoid-all"] },
            })
            .toPdf()
            .output("blob")
            .then((pdfBlob) => {
__ea_trace("modules/consent/consent.ts","(anon)",[pdfBlob],["pdfBlob"]);
              var pdfFile = new File(
                [pdfBlob],
                isDataConsentAgreement
                  ? "DataConsentagreement.pdf"
                  : isSubAgreement
                    ? "Subagreement.pdf"
                    : "Disclosure.pdf",
                { type: "application/pdf" },
              )

              var formData = new FormData()
              formData.append("file", pdfFile)

              fetch("https://aws.nautilussolar.com/testRoute/uploadFileToFileManager", {
                method: "POST",
                body: formData,
              })
                .then((response) => {
__ea_trace("modules/consent/consent.ts","(anon)",[response],["response"]);
                  if (response.ok) {
                    response
                      .json()
                      .then((result) => {
__ea_trace("modules/consent/consent.ts","(anon)",[result],["result"]);
                        if (isSubAgreement) {
                          SubAgreementUrl = result.response.url
                        } else {
                          DiscAgreementUrl = result.response.url
                        }
                        resolve()
                      })
                      .catch((error) => reject(error))
                  } else {
                    reject(
                      new Error(
                        `Error uploading ${isSubAgreement ? "sub" : isDataConsentAgreement ? "dataCon" : "disc"} agreement file. Status: ${response.status}`,
                      ),
                    )
                  }
                })
                .catch((error) => reject(error))
            })
            .catch((error) => reject(error))
        } else {
          await html2pdf()
            .from(container)
            .set({
              margin: [20, 30, 80, 30],
              filename: "template.pdf",
              html2canvas: {
                scale: 2,
                useCORS: true,
              },
              jsPDF: { unit: "pt", format: "a4", orientation: "portrait" },
              pagebreak: { mode: ["css", "avoid-all"] },
            })
            .toPdf()
            .output("blob")
            .then((pdfBlob) => {
__ea_trace("modules/consent/consent.ts","(anon)",[pdfBlob],["pdfBlob"]);
              var pdfFile = new File(
                [pdfBlob],
                isDataConsentAgreement
                  ? "DataConsentagreement.pdf"
                  : isSubAgreement
                    ? "Subagreement.pdf"
                    : "Disclosure.pdf",
                { type: "application/pdf" },
              )

              var formData = new FormData()
              formData.append("file", pdfFile)

              fetch("https://aws.nautilussolar.com/testRoute/uploadFileToFileManager", {
                method: "POST",
                body: formData,
              })
                .then((response) => {
__ea_trace("modules/consent/consent.ts","(anon)",[response],["response"]);
                  if (response.ok) {
                    response
                      .json()
                      .then((result) => {
__ea_trace("modules/consent/consent.ts","(anon)",[result],["result"]);
                        if (isSubAgreement) {
                          SubAgreementUrl = result.response.url
                          _SubAgreementId = result.response.id
                        } else {
                          DiscAgreementUrl = result.response.url
                          _DiscAgreementId = result.response.id
                        }
                        resolve()
                      })
                      .catch((error) => reject(error))
                  } else {
                    reject(
                      new Error(
                        `Error uploading ${isSubAgreement ? "sub" : "disc"} agreement file. Status: ${response.status}`,
                      ),
                    )
                  }
                })
                .catch((error) => reject(error))
            })
            .catch((error) => reject(error))
        }
        document.body.removeChild(container)
      } catch (e) {
        console.error("Error in convertAndUploadPdf:", e)
        reject(e)
      }
    })
  }
  function checkIfCanvasIsBlank(canvas) {
__ea_trace("modules/consent/consent.ts","checkIfCanvasIsBlank",[canvas],["canvas"]);
    const context = canvas.getContext("2d")
    const pixelData = context.getImageData(0, 0, canvas.width, canvas.height).data

    for (let i = 0; i < pixelData.length; i += 4) {
      const [r, g, b, a] = pixelData.slice(i, i + 4)
      if (a !== 0 && (r !== 255 || g !== 255 || b !== 255)) {
        return false
      }
    }
    return true
  }
  async function printSubAgreement() {
__ea_trace("modules/consent/consent.ts","printSubAgreement",[],[]);
    try {
      if (!(await ensureTemplatesReady())) return
      var customHTML = finalSubTemp

      // Create an iframe
      var iframe = document.createElement("iframe")
      iframe.style.width = "0"
      iframe.style.height = "0"
      document.body.appendChild(iframe)

      iframe.contentDocument.write(customHTML)
      iframe.contentDocument.close()

      iframe.contentWindow.print()
    } catch (e) {
      console.error(`Error in print: ${e}`)
    }
  }
  async function printDisclosure() {
__ea_trace("modules/consent/consent.ts","printDisclosure",[],[]);
    try {
      if (!(await ensureTemplatesReady())) return
      var customHTML = finalDisclosureTemp

      // Create an iframe
      var iframe = document.createElement("iframe")
      iframe.style.width = "0"
      iframe.style.height = "0"
      iframe.style.border = "none"
      document.body.appendChild(iframe)

      iframe.contentDocument.write(customHTML)
      iframe.contentDocument.close()

      iframe.onload = () => {
__ea_trace("modules/consent/consent.ts","(anon)",[],[]);
        iframe.contentWindow.focus()
        iframe.contentWindow.print()
        setTimeout(() => {
__ea_trace("modules/consent/consent.ts","(anon)",[],[]);
          document.body.removeChild(iframe)
        }, 1000)
      }
    } catch (e) {
      console.error(`Error in print: ${e}`)
    }
  }

  setTimeout(() => {
__ea_trace("modules/consent/consent.ts","(anon)",[],[]);
    pageloaded = true
  }, 5000)

  // pdf and print ---------------------------------------------------------------------

  var is_enrolled_for_bayou = storage.rawGet("is_enrolled_for_bayou")

  // ─── Wire formerly-inline handlers ────────────────────────────────────────────

  // Agreement preview popups (onclick attrs stripped from #sa-view-a-copy-anchor
  // and #dsc-view-a-copy-anchor)
  bind("#sa-view-a-copy-anchor", "click", () => previewSubTemplate())
  bind("#dsc-view-a-copy-anchor", "click", () => previewDiscTemplate())
}
